import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SignInComponent } from './core/authentication/sign-in/sign-in.component';
import { SignUpComponent } from './core/authentication/sign-up/sign-up.component';
import { ForgetPasswordComponent } from './core/authentication/forget-password/forget-password.component';
import { QuestionsAnswerComponent } from './core/authentication/welcome/questions-answer/questions-answer.component';
import { ChooseProfileComponent } from './core/authentication/welcome/choose-profile/choose-profile.component';
import { PersonalInfoComponent } from './core/authentication/welcome/personal-info/personal-info.component';
import { CommunityGroupsComponent } from './core/authentication/welcome/community-groups/community-groups.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AuthguardService } from './services/authguard.service';
import { CategoriesComponent } from './categories/categories.component';
import { CategoryViewComponent } from './category-view/category-view.component';
import { RoadmapComponent } from './roadmap/roadmap.component';
import { GroupsComponent } from './groups/groups.component';
import { GroupsViewComponent } from './groups-view/groups-view.component';
import { ChallengesComponent } from './challenges/challenges.component';
import { ChallengesViewComponent } from './challenges-view/challenges-view.component';
import { ChallengesNewComponent } from './challenges-new/challenges-new.component';
import { HelpComponent } from './help/help.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { SuggestionsComponent } from './suggestions/suggestions.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { ActivitiesComponent } from './activities/activities.component'; 

const routes: Routes = [

	{
		path: '',
		redirectTo: 'dashboard',
		data: { name: 'Dashboard' },
		pathMatch: 'full'
	},
	{
		path: 'login',
		data: { name: 'Login' },
		component: SignInComponent,
	},
	{
		path: 'signup',
		data: { name: 'Signup' },
		component: SignUpComponent,
	},
	{
		path: 'forget',
		data: { name: 'ForgetPassword' },
		component: ForgetPasswordComponent,
	},
	{
		path: 'dashboard',
		data: { name: 'Dashboard' },
		component: DashboardComponent,
		canActivate: [AuthguardService]
	},
	{
		path: 'questions-answer',
		data: { name: 'Questions Answer' },
		component: QuestionsAnswerComponent,
		canActivate: [AuthguardService]
	},
	{
		path: 'welcome',
		data: { name: 'Welcome' },
		component: ChooseProfileComponent,
		canActivate: [AuthguardService]
	},
	{
		path: 'personal-info',
		data: { name: 'Personal Info' },
		component: PersonalInfoComponent,
		canActivate: [AuthguardService]
	},
	{
		path: 'community-groups',
		data: { name: 'Community Groups' },
		component: CommunityGroupsComponent,
		canActivate: [AuthguardService]
	},
	{
		path: 'categories',
		data: { name: 'Categories' },
		component: CategoriesComponent,
		canActivate: [AuthguardService]
	},
	{
		path: 'category-view/:cat_id',
		data: { name: 'Categories' },
		component: CategoryViewComponent,
		canActivate: [AuthguardService]
	},
	{
		path: 'roadmap',
		data: { name: 'Roadmap' },
		component: RoadmapComponent,
		canActivate: [AuthguardService]
	},
	{
		path: 'groups',
		data: { name: 'Groups' },
		component: GroupsComponent,
		canActivate: [AuthguardService]
	},
	{
		path: 'groups-view/:id',
		data: { name: 'Groups' },
		component: GroupsViewComponent,
		canActivate: [AuthguardService]
	},
	{
		path: 'challenges',
		data: { name: 'Challenges' },
		component: ChallengesComponent,
		canActivate: [AuthguardService]
	},
	{
		path: 'challenges-view/:ch_id',
		data: { name: 'Challenges' },
		component: ChallengesViewComponent,
		canActivate: [AuthguardService]
	},
	{
		path: 'challenges-new',
		data: { name: 'Challenges' },
		component: ChallengesNewComponent,
		canActivate: [AuthguardService]
	},
	{
		path: 'help',
		data: { name: 'Help' },
		component: HelpComponent,
		canActivate: [AuthguardService]
	},
	{
		path: 'notifications',
		data: { name: 'Notifications' },
		component: NotificationsComponent,
		canActivate: [AuthguardService]
	},
	{
		path: 'suggestions',
		data: { name: 'Suggestions' },
		component: SuggestionsComponent,
		canActivate: [AuthguardService]
	},
	{
		path: 'profile',
		data: { name: 'Profile' },
		component: UserProfileComponent,
		canActivate: [AuthguardService]
	},
	{
		path: 'activities',
		data: { name: 'Logged Activities' },
		component: ActivitiesComponent,
		canActivate: [AuthguardService]
	},
	{
		path: '**',
		redirectTo: '/dashboard'
	},

];

@NgModule({
	imports: [RouterModule.forRoot(routes, { useHash: true })],
	exports: [RouterModule]
})
export class AppRoutingModule { }
